module.exports = require('./helpers/bundle-url').getBundleURL('jI9C4') + "logo-dark.eefe0b7f.svg";